<template>
  <section class="c-carousel">
    <div
      id="destinations-carousel"
      class="owl-carousel owl-theme owl-carousel--grayscale"
    >
      <div
        class="item"
        v-for="destination in destinations"
        :key="destination.id"
        :style="{ backgroundImage: `url(${destination.imgUrl})` }"
      >
        <p class="slide-text">
          <span class="slide-title">{{
            getTitle(destination).toUpperCase()
          }}</span
          ><br />
          <span @mouseover="pause" @mouseleave="play">
            <el-button :data-destination="destination.id" type="primary"
              >{{ $t("DESTINATION__CHOOSE_BTN") }}&nbsp;&nbsp;<i
                class="fas fa-car-side"
              ></i
            ></el-button>
          </span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel"
import $ from "jquery"
import { isMobile } from "mobile-device-detect"

import { capitalize } from "../helpers/string"

const { mapState, mapMutations } = createNamespacedHelpers("app")

export default {
  name: "DestinationCarousel",
  computed: {
    ...mapState(["destinations"])
  },
  data() {
    return {
      autoplay: true,
      autoplayDelay: 3000
    }
  },
  methods: {
    ...mapMutations(["setUserDestination", "setSelectedDestination"]),
    initCarousel() {
      const vm = this
      $(document).ready(function() {
        $(".owl-carousel").owlCarousel({
          items: 1,
          nav: true,
          navText: [
            "<i class='fas fa-angle-left' id='prevNav'></i>",
            "<i class='fas fa-angle-right' id='nextNav'></i>"
          ],
          loop: true,
          autoplay: vm.autoplay,
          autoplayTimeout: 7000,
          lazyLoad: true,
          responsiveClass: true,
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 0
            },
            // breakpoint from 480 up
            768: {
              stagePadding: 100
            }
          }
        })

        $("[data-destination]").on("click", function() {
          const destinationId = $(this).data("destination")
          const destination = vm.destinations.find(d => d.id === destinationId)
          vm.setDestination(destination)
        })
      })
    },
    destroyCarousel() {
      const container = $("#destinations-carousel")
      const vm = this
      if (container.hasClass("owl-carousel")) {
        container.owlCarousel({
          touchDrag: false,
          mouseDrag: false
        })
        container.trigger("destroy.owl.carousel")
        container.removeClass("owl-loaded")
        container
          .find(".owl-stage-outer")
          .children()
          .unwrap()
        container.removeData()
      }
      $("[data-destination]").off("click", function() {
        const destinationId = $(this).data("destination")
        const destination = vm.destinations.find(d => d.id === destinationId)
        vm.setDestination(destination)
      })
    },
    pause() {
      const container = $("#destinations-carousel")
      container.trigger("stop.owl.autoplay")
    },
    play() {
      if (!this.autoplay) return
      const container = $("#destinations-carousel")
      container.trigger("play.owl.autoplay")
    },
    attachNavClickEvents() {
      $("body").on("click", "#nextNav", this.pause)
      $("body").on("click", "#prevNav", this.pause)
    },
    removeNavClickEvents() {
      $("body").off("click", "#nextNav", this.pause)
      $("body").off("click", "#prevNav", this.pause)
    },
    getTitle(destination) {
      return destination[`title${capitalize(this.$i18n.locale)}`]
    },
    setDestination(destination) {
      this.setUserDestination(destination.id)
      this.setSelectedDestination(destination)
      this.autoplay = false
      this.pause()
      this.$emit("destinationUpdated", destination)
    }
  },
  created() {
    this.autoplay = !isMobile
  },
  mounted() {
    this.$nextTick(() => {
      this.initCarousel()
      this.attachNavClickEvents()

      if (this.autoplay) {
        this.pause()
        setTimeout(() => {
          this.play()
        }, this.autoplayDelay)
      }
    })
  },
  beforeDestroy() {
    this.removeNavClickEvents()
    this.destroyCarousel()
  }
}
</script>

<style scoped></style>
